import moment from 'moment';

export function ucWords(str) {
	const strLower = str.toLowerCase();
	const re = /(^([a-zA-Z\p{M}]))|([ -][a-zA-Z\p{M}])/gu;
	return strLower.replace(re, s => s.toUpperCase());
}

export function isEmpty(value) {
	return (
		typeof value === 'undefined' ||
		value === undefined ||
		value === '' ||
		value === null ||
		(typeof value === 'object' && Object.keys(value).length === 0)
	);
}

export function montarEndereco(endereco = {}) {
	if (isEmpty(endereco)) {
		return '';
	}

	let strEndereco = '';
	let separador = false;

	if ('logradouro' in endereco && !isEmpty(endereco.logradouro)) {
		strEndereco += endereco.logradouro;
		separador = true;
	}

	if ('numero' in endereco && !isEmpty(endereco.numero)) {
		if (separador) strEndereco += ', ';
		strEndereco += endereco.numero;
		separador = true;
	}

	if ('bairro' in endereco && !isEmpty(endereco.bairro)) {
		if (separador) strEndereco += ' - ';
		strEndereco += endereco.bairro;
		separador = true;
	}

	if ('cidade' in endereco && !isEmpty(endereco.cidade)) {
		if (separador) strEndereco += ', ';
		strEndereco += endereco.cidade;
		separador = true;
	}

	if ('estado' in endereco && !isEmpty(endereco.estado)) {
		if (separador) strEndereco += ' - ';
		strEndereco += endereco.estado;
	}

	if ('referencia' in endereco && !isEmpty(endereco.referencia)) {
		strEndereco += `<br>${endereco.referencia}`;
	}

	return ucWords(strEndereco);
}

export function removeSegundos(dataPt) {
	if (!isEmpty(dataPt)) {
		return moment(dataPt, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY HH:mm');
	}
	return '';
}

export async function notifyDesktop(options) {
	if (!('Notification' in window)) {
		console.log('Navegador não suporta o serviço de notificação');
		return null;
	}

	const permission = await Notification.requestPermission();
	if (permission !== 'granted') {
		console.log('Permissão de notificação negada');
		return null;
	}

	var n = new Notification(options.title, options);
	n.onerror = function (event) {
		console.log(event);
	};
	return n;
}

export function mensagemRetorno(error, response, mensagemPadrao) {
	let message = mensagemPadrao;

	if (error === true) {
		if (
			response?.response?.status < 500 &&
			response?.response?.data?.mensagem
		) {
			message = response.response.data.mensagem;
		}
	} else {
		if (response?.data?.mensagem) {
			message = response.data.mensagem;
		}
	}

	return { error, message };
}

export function substituiVazio(str, substituirPor = '') {
	return isEmpty(str) ? substituirPor : str;
}

/**
 * Converte tempo no formato hh:mm:ss para minutos
 */
export function tempoEmMinutos(tempo) {
	if (isEmpty(tempo)) return 0;

	const [horas, minutos] = tempo.split(':').map(Number);
	return horas * 60 + minutos;
}

export function uniqueID() {
	return Math.floor(Math.random() * Math.floor(Math.random() * Date.now()));
}

export function trucarTexto(texto, de, ate) {
	if (isEmpty(texto)) {
		return '';
	}

	if (!de) {
		de = 0;
	}

	if (!ate || ate < de) {
		de = texto.length;
	}

	let textoTruncado = texto.substring(de, ate);

	if (textoTruncado.length < texto.length) {
		textoTruncado += ' ... ';
	}

	return textoTruncado;

}

export function slideDown(el, duration = 300) {
	el.style.removeProperty('display'); // remove display: none se tiver

	let display = window.getComputedStyle(el).display;
	if (display === 'none') display = 'block';
	el.style.display = display;

	const height = el.scrollHeight;

	el.style.overflow = 'hidden';
	el.style.height = '0px';
	el.offsetHeight; // força repaint

	el.style.transition = `height ${duration}ms ease`;
	el.style.height = height + 'px';

	setTimeout(() => {
		el.style.removeProperty('height');
		el.style.removeProperty('overflow');
		el.style.removeProperty('transition');
	}, duration);
}

export function slideUp(el, duration = 300) {
	el.style.height = el.scrollHeight + 'px';
	el.style.overflow = 'hidden';
	el.offsetHeight; // força repaint

	el.style.transition = `height ${duration}ms ease`;
	el.style.height = '0px';

	setTimeout(() => {
		el.style.display = 'none';
		el.style.removeProperty('height');
		el.style.removeProperty('overflow');
		el.style.removeProperty('transition');
	}, duration);
}
